const CONTACT_US_FOR_FREIGHT_QUOTE_BUTTON_LABEL = 'CONTACT US FOR PRICING';
const ADD_TO_CART_BUTTON_LABEL = 'ADD TO CART';

document.addEventListener('DOMContentLoaded', function () {
  const input = document.querySelector('input[name="id"]');
  if (!input) return;

  let currentValue = input.value;

  // Watch for .value assignment directly
  Object.defineProperty(input, 'value', {
    get() {
      return currentValue;
    },
    set(newValue) {
      currentValue = newValue;
      onVariantChange(newValue);
    }
  });

  // Watch for attribute changes (e.g., setAttribute)
  const observer = new MutationObserver(() => {
    const newValue = input.getAttribute('value');
    if (newValue !== currentValue) {
      currentValue = newValue;
      onVariantChange(newValue);
    }
  });

  observer.observe(input, { attributes: true, attributeFilter: ['value'] });

  function onVariantChange(variantId) {
    const variantInfo = document.querySelector(`.hidden-variant-info[data-variant-id="${variantId}"]`);
    if (!variantInfo) return;

    const price = parseFloat((variantInfo.getAttribute('data-price') || '0').replace(/[^0-9.]/g, '').trim());
    const boardLength = parseInt(variantInfo.getAttribute('data-board-length') || '0');
    const sqftPerLinearFt = parseFloat(variantInfo.getAttribute('data-sqft-per-lf') || '0');
    const boardsPerUnit = parseInt(variantInfo.getAttribute('data-boards-per-unit') || '1');
    const sqft = boardsPerUnit * boardLength * sqftPerLinearFt;
    const priceSqft = price / sqft;

    const disallowInCart = variantInfo.getAttribute('data-disallow-in-cart');
    const soldPerBox = variantInfo.getAttribute('data-sold-per-box');
    document.getElementById("quantityBoxesOrBoards").innerHTML = `${soldPerBox === `true` ? `boxes` : `boards`}`;

    console.log(`price=${price}; boardLength=${boardLength}; sqftPerLinearFt=${sqftPerLinearFt}; boardsPerUnit=${boardsPerUnit}; sqft=${sqft}; priceSqft=${priceSqft}; disallowInCart=${disallowInCart}`);

    const formattedPrice = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(price);

    const formattedPriceSqft = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(priceSqft);

    console.log('Variant changed:', {
      sqft,
      formattedPrice,
      formattedPriceSqft,
      disallowInCart,
      soldPerBox
    });

    const sqftPerBoxInput = document.getElementById("SqftPerBox");
    if (sqftPerBoxInput) {
      sqftPerBoxInput.value = sqft;
    }


    // ✅ Update price area
    const priceList = document.querySelector('price-list.sale-price, price-list');
    if (priceList) {
      // alert(`disallowInCart=${disallowInCart}; soldPerBox=${soldPerBox}`)
      if (soldPerBox === 'true') {
        priceList.innerHTML = `
          <sale-price class="h4 text-subdued">
            <span class="sr-only">Sale price </span>
            <!-- <div>${formattedPrice} per box of ${boardsPerUnit} boards (${boardLength}')</div> -->
            <div  style="font-size: 22.5px; x-margin-top: -20px;">${formattedPriceSqft} per sq. ft.</div>
          </sale-price>
        `;
      } else {
        priceList.innerHTML = `
          <sale-price class="h4 text-subdued">
            <!-- <span class="sr-only">Sale price </span>
            ${formattedPriceSqft} per sq. ft. -->
            <span class="sr-only">Sale price </span>
            <!-- <div>${formattedPrice} per board (${boardLength}')</div> -->
            <div style="font-size: 22.5px; x-margin-top: -20px;">${formattedPriceSqft} per sq. ft.</div>
          </sale-price>
        `;
      }
    }

    // ✅ Update Buy Button Text (supports multiple buy-buttons)
    updateBuyButtonText(disallowInCart);


    autofillVariantFields(variantInfo);

    // if (disallowInCart === 'false') {
    //   const squareCalcContainer = document.getElementById('SquareCalcContainer');
    //   if (squareCalcContainer) {
    //     squareCalcContainer.style.display = 'block';
    //   }
    // } else {
    //   const squareCalcContainer = document.getElementById('SquareCalcContainer');
    //   if (squareCalcContainer) {
    //     squareCalcContainer.style.display = 'none';
    //   }
    // }
  }

  function updateBuyButtonText(disallowInCart) {
    let attempts = 0;
    const maxAttempts = 10;

    const interval = setInterval(() => {
      const buyButtons = document.querySelectorAll('buy-buttons button[type="submit"]');

      if (buyButtons.length) {
        buyButtons.forEach(button => {
          button.textContent = (disallowInCart === 'false')
            ? ADD_TO_CART_BUTTON_LABEL
            : CONTACT_US_FOR_FREIGHT_QUOTE_BUTTON_LABEL;
        });
        handleQuantityRefresh();
        clearInterval(interval);
      }
      if (++attempts > maxAttempts) {
        console.warn('Buy buttons not found after multiple attempts');
        clearInterval(interval);
      }
    }, 5);
  }
  document.addEventListener('click', function (e) {
  // Only act on buttons inside <buy-buttons>
  const isBuyButton = e.target.closest('buy-buttons button[type="submit"]');
  if (!isBuyButton) return;

  // Normalize the text (in case of extra spaces or casing)
  const buttonText = e.target.textContent.trim().toLowerCase();

  if (buttonText === CONTACT_US_FOR_FREIGHT_QUOTE_BUTTON_LABEL.trim().toLowerCase()) {
    e.preventDefault();
    console.log('Freight quote required — form submission blocked.');

    // You can also trigger a modal or custom action here
    // Open the contact modal when the buy button says CONTACT_US_FOR_FREIGHT_QUOTE_BUTTON_LABEL
    const contactModal = document.getElementById('contactModal');
    if (contactModal) {
      contactModal.style.display = 'flex';
    }
  } else {
    const userEnteredQuantity = parseInt(document.getElementById('shopifyQuantity').value);
    console.info(`userEnteredQuantity: ${userEnteredQuantity}`);



  }
  });

  function autofillVariantFields(variantInfo) {
    console.log('Autofilling variant fields:', variantInfo);
    if (variantInfo) {
      var woodType = variantInfo.getAttribute('data-wood-type') || '';
      var boardLength = variantInfo.getAttribute('data-board-length') || '';
      var woodTypeInput = document.getElementById('ContactFormWoodType');
      var boardLengthInput = document.getElementById('ContactFormBoardLength');
      if (woodTypeInput) woodTypeInput.value = woodType;
      if (boardLengthInput) boardLengthInput.value = boardLength;
    }
  }
  // DOM references
  const quantityInput = document.getElementById('shopifyQuantity');
  const extraInput = document.getElementById('SquareCalcExtra');
  const quantityNotes = document.getElementById('quantityNotes');
  const quantityBoxesOrBoards = document.getElementById('quantityBoxesOrBoards');



  const sqftFormField = document.getElementById('ContactFormSqft');
  const boxesFormField = document.getElementById('ContactFormBoardsBoxes');
  const sqftPerBoxInput = document.getElementById('SqftPerBox');
  const requiredBoxesField = document.getElementById('RequiredBoxes');
  const contactLength = document.getElementById('ContactFormLength');

  let lastWidthSource = null;
  let lastLengthSource = null;
  let lastSqftSource = null;

  function getBaseValue(el) {
    return parseFloat(el?.dataset.baseValue || el?.value) || 0;
  }


  let baseWidth = 0;
  let baseLength = 0;
  let baseSqft = 0;

  /**
   * Note: trigger is checkbox, input, or the default (auto)
   */
  function handleQuantityRefresh(trigger = 'auto') {
    if (!quantityNotes) {
      return;
    }
    let quantityVal = parseInt(quantityInput?.value);
    const sqftPerBox = parseFloat(document.getElementById('SqftPerBox')?.value) || 0;
    const isExtra = extraInput?.checked;
    const btnText = document.querySelector('.shopify-product-form button[type="submit"]')?.textContent || '';

    // Use last known base value unless user changed something
    if (trigger !== 'checkbox') {
      console.info(`CHECKBOX NOT CHECKED; trigger was ${trigger}`);
    }

    // Adjusted values (with or without 10% extra)

    const adjLength = isExtra ? baseLength * 1.1 : baseLength;
    const adjSqft = isExtra ? baseSqft * 1.1 : baseSqft;
    if (quantityInput) {
      const quantityInputInt = parseInt(quantityInput.value);
      console.info(`quantityInputInt=${quantityInputInt}`);
      if (isNaN(quantityInputInt) || quantityInputInt < 1) {
        quantityVal = 1;
        quantityInput.value = `${quantityVal}`;
      }
      quantityInput.value = `${Math.floor(quantityInput.value)}`;
    }

    const hiddenInput = document.querySelector('input[name="id"]');
    const variantInfo = document.querySelector(`.hidden-variant-info[data-variant-id="${hiddenInput.value}"]`);
    const price = parseFloat((variantInfo.getAttribute('data-price') || '0').replace(/[^0-9.]/g, '').trim());
    const boardLength = parseInt(variantInfo.getAttribute('data-board-length') || '0');
    const sqftPerLinearFt = parseFloat(variantInfo.getAttribute('data-sqft-per-lf') || '0');
    const boardsPerUnit = parseInt(variantInfo.getAttribute('data-boards-per-unit') || '1');
    const sqft = boardsPerUnit * boardLength * sqftPerLinearFt;
    const priceSqft = price / sqft;
    const soldPerBox = variantInfo.getAttribute('data-sold-per-box');

    /*
    We are doing one of these:

    5 boxes = 20 boards, 28.13 SF
    $1,722.50 incl. shipping

    - or - 

    5 boards = 21.09 SF (no minimum)
    $1,297.70 + freight at checkout

    ...Also, see product-info.liquid, which needs to write IDENTICAL lines to the product page, but
    using luquid logic.
    */
    let notesHTML;
    const totalBoards = boardsPerUnit * quantityVal;
      if (!isNaN(quantityVal)) {
            const formattedSubtotal = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(quantityVal * price);
      const sqftFormatted = format((quantityVal * boardLength * boardsPerUnit) * sqftPerLinearFt);
      if (soldPerBox === `true`) {
        notesHTML = `${quantityVal} box${quantityVal > 1 ? `es` : ``} 
          = ${totalBoards} boards, ${sqftFormatted} SF<br/>  
          ${formattedSubtotal} incl. shipping`;
      } else {
        notesHTML = `${quantityVal} board${quantityVal > 1 ? `s` : ``} 
          = ${sqftFormatted} SF (no minimum)<br/>
          ${formattedSubtotal} + freight at checkout`;
      }
    } else {
      notesHTML = '&nbsp;';
    }
    quantityNotes.innerHTML = notesHTML;
  }
const format = (num) => {
    return `${Math.round(num * 100) / 100}`;
};








  function debounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  }


  function handleInput(sourceRef, setLastSource) {
    return (e) => {
      e.target.dataset.baseValue = e.target.value;
      setLastSource(e.target);
      debouncedCalc();
    };
  }

  const debouncedCalc = debounce(() => handleQuantityRefresh('input'), 500);
    
  if (quantityInput) quantityInput.addEventListener('input', debouncedCalc);
  if (document.getElementById('ContactFormSqft')) {
    document.getElementById('ContactFormSqft').addEventListener('input', debouncedCalc);
  }

  [quantityInput].forEach(el => {
    if (el) el.addEventListener('input', debouncedCalc);
  });

  const contactSqft = document.getElementById('ContactFormSqft');
  if (contactSqft) contactSqft.addEventListener('input', debouncedCalc);

  document.body.addEventListener('change', function(e) {
    if (
      e.target?.matches('#SquareCalcExtra') ||
      e.target?.matches('#SquareCalcExtra-Contact')
    ) {
      handleQuantityRefresh('checkbox');
    }
  });

  // Listen for quantity-selector +/- button clicks
  document.body.addEventListener('click', function(e) {
    var button = e.target.closest('quantity-selector .quantity-selector__button');
    if (button) {
      // Small delay to let the quantity-selector update the input value first
      setTimeout(function() { handleQuantityRefresh('button'); }, 10);
    }

    // Contact for trade pricing link opens the same modal as freight quote button
    if (e.target.closest('#contact-for-trade-pricing')) {
      var contactModal = document.getElementById('contactModal');
      if (contactModal) {
        contactModal.style.display = 'flex';
      }
    }
  });
});